//external
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
//internal
import { deleteChecklist, getChecklist } from 'services/checklist/service';
import history from 'services/history';
import { startRequest, finishRequest } from 'store/modules/loading/actions';
import ContentPanel from 'components/ContentPanel';
import { setMessage } from 'store/modules/message/action';
import { sanitizeErrorUI } from 'utils/errorUtil';
//style
import { Attr, AttrName } from './styled';
import { Button, ButtonContainer } from 'styles/components';

export default function ChecklistDelete({match}) {
  const checklistId = match.params.id;
  const message = useSelector(state => state.message.data);
  const [checklist, setChecklist] = useState();

  const dispatch = useDispatch();

  useEffect(() => {
    if (checklistId) {
      dispatch(startRequest());
      getChecklist(checklistId).then(data => {
        setChecklist(data.data);
      }).catch(err => {
        dispatch(setMessage(sanitizeErrorUI(err)));
      }).finally(() => {
        dispatch(finishRequest());
      });
    }
  }, [dispatch, checklistId]);

  async function handleDelete () {
    dispatch(startRequest());
    deleteChecklist(checklistId).then(data => {
      history.push('/checklist')
    }).catch(err => {
      dispatch(setMessage(sanitizeErrorUI(err)));
    }).finally(() => {
      dispatch(finishRequest());
    });
  }

  async function handleBack () {
    history.goBack();
  }

  return (
    <>
      <ContentPanel title="Deseja excluir esta matéria prima?" message={message}>
        {checklist && <>
          <AttrName>Descrição:</AttrName>
          <Attr>{checklist.description}</Attr>
          <ButtonContainer>
            <br />
            <Button left={true} cancel={true} onClick={handleBack}>
              Voltar
            </Button>
            <Button onClick={handleDelete}>
              Excluir
            </Button>
          </ButtonContainer>
        </>}
      </ContentPanel>
    </>
  )
}